import {
  SurveyPostAnswerMetaSvend,
  SurveyPostData,
  SurveyResolver
} from '@surveycake/logic-engine';
import { http } from './http';

export type SubmitResponseDataRedirect = SurveyPostAnswerMetaSvend | 'fulled';
export interface SubmitResponseData {
  fileHash: string;
  redirect: SubmitResponseDataRedirect;
}

/**
 * For the `resolver.count` of `LogicEngine`.
 */
export const getCount: SurveyResolver['count'] = async ({
  surveyHash,
  subjectId,
  type,
  value
}) => {
  try {
    const queryParams = http.query({
      svid: surveyHash,
      sbjid: subjectId,
      [type]: type === 'optid' || type === 'vtext' ? value : ''
    });
    const url = http.url.api(`/s/ans/count?${queryParams}`, 1);
    const res = await http.get(url);
    const { status, anscount, errmsg = '' } = await http.handleResponse(res);

    if (!status) {
      throw new Error(errmsg);
    }

    return parseInt(anscount, 10) || 0;
  } catch (error) {
    throw error;
  }
};

/**
 * To get the report token for public result.
 */
export async function getReportToken(svid: string): Promise<string> {
  try {
    const url = http.url.api(
      `/s/survey/report/token?${http.query({ svid })}`,
      1
    );
    const res = await http.get(url);
    const { status, data, errmsg = '' } = await http.handleResponse(res);

    if (!status) {
      throw new Error(errmsg);
    }

    return data;
  } catch (error) {
    throw error;
  }
}

/**
 * To submit the answer data and extra data to server.
 */
export async function submit(
  postData: SurveyPostData
): Promise<SubmitResponseData> {
  try {
    const { ansobj, re_captcha: reCAPTCHA, previewObj } = postData;
    const url = http.url.api(`/s/submit`, 1);
    const body = new FormData();
    body.append('ansobj', JSON.stringify(ansobj));
    body.append('previewObj', JSON.stringify(previewObj));

    if (reCAPTCHA) {
      body.append('re_captcha', reCAPTCHA);
    }

    const res = await http.post(url, { body });
    const { status, data, errmsg = '' } = await http.handleResponse(res);

    if (!status) {
      throw new Error(errmsg);
    }

    return data;
  } catch (error) {
    throw error;
  }
}
